import { Accordion } from "../global";

export class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.productForm = document.getElementById('oli-product-form');
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.updateURL();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${ this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const changeSelectors = [
          `#product-form-retailers-check`,
          `#product-featured-image-oli-product-gallery`,
          `#product-ingredients-section`,
          `#product-size-description`,
          `#product-flavor-description`,
          `#product-form-retailers`,
          `#product-form-beam-widget`
        ];

        changeSelectors.forEach(selector => {
          const destination = document.querySelector(selector);
          const source = html.querySelector(selector);
          if (destination && source) destination.innerHTML = source.innerHTML;
        })

        const accordions = document.querySelectorAll('accordion-group');

        if (accordions.length) {
          accordions.forEach(accordion => {
            // eslint-disable-next-line no-new
            new Accordion(accordion);
          });
        }

        // check if it retailer variant
        const retailerVariantInput = document.querySelector('#product-form-retailers-input');

        if (retailerVariantInput) {
          document.querySelector('#product-form-content')?.classList.add('hide');
          document.querySelector('[data-sticky-add-to-cart]')?.classList.add('hide');
          document.body.classList.add('is-retailer-variant');
        } else {
          document.querySelector('#product-form-content:not(.hide-dtc)')?.classList.remove('hide');
          document.querySelector('[data-sticky-add-to-cart]')?.classList.remove('hide');
          document.body.classList.remove('is-retailer-variant');
        }

      });
  }


  setUnavailable() {
    const addButton = this.productForm.querySelector('[name="add"]');
    const addButtonText = this.productForm.querySelector('[name="add"] > span');

    if (!addButton) return;
    addButton.setAttribute('disabled', 'disabled')
    addButtonText.textContent = theme.strings.unavailable;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('variant-radios')) {
    customElements.define('variant-radios', VariantRadios);
  }
})